// Declare all custom elements

import AutoHideOverflow from "./components/AutoHideOverflow";
customElements.define('auto-hide-overflow', AutoHideOverflow, {extends: 'div'});

import AutoSplide from "./components/AutoSplide";
customElements.define('auto-splide', AutoSplide, {extends: 'div'});

// Le composant CollapseLongContent est surgchargé dans l'app
// import CollapseLongContent from "./components/CollapseLongContent";
// customElements.define('collapse-long-content', CollapseLongContent);

import InputPassword from "./components/InputPassword";
customElements.define('input-password', InputPassword);

import ProductGallery from "./components/ProductGallery";
customElements.define('product-gallery', ProductGallery);

// Le composant QuantitySelector est surgchargé dans l'app
// import QuantitySelector from "./components/QuantitySelector";
// customElements.define('quantity-selector', QuantitySelector);

// Le composant SearchProducts est surgchargé dans l'app
// import SearchProducts from "./components/SearchProducts";
// customElements.define('search-products', SearchProducts, {extends: 'div'});

import SiteFooter from "./components/SiteFooter";
customElements.define('site-footer', SiteFooter);

// Le composant SiteHeader est surgchargé dans l'app
// import SiteHeader from "./components/SiteHeader";
// customElements.define('site-header', SiteHeader);

import initTableGroupToggles from './components/ToggleTableGroups';
document.addEventListener("DOMContentLoaded", () => {
    initTableGroupToggles();
});

// On charge uniquement les modules bootstrap utiles

// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';
import Tooltip from 'bootstrap/js/dist/tooltip';

document.addEventListener("DOMContentLoaded", () => {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach(el => new Tooltip(el));
});

// Pour la compatibilité pleine et entière avec les modules Hegyd (notamment Modalator.js)
// on est malheureusement obligé de charger bootstrap de cette manière...
window.bootstrap = require('bootstrap');
